<template>
  <div class="home">
    <div class="oneCon">
      <el-carousel :interval="5000" :height="imgHeight">
        <el-carousel-item>
          <img id="carouselImg" src="../assets/banner1.png" alt="">
        </el-carousel-item>
        <el-carousel-item>
          <img src="../assets/banner2.png" alt="">
        </el-carousel-item>
        <el-carousel-item>
          <img src="../assets/banner1.png" alt="">
        </el-carousel-item>
        <el-carousel-item>
          <img src="../assets/banner2.png" alt="">
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="twoCon">
      <div class="widthCon">
        <div class="left">
        <div class="title">关于我们</div>
        <div class="content">A星计划是由加拿大ALPHASTAR GLOBAL HOLDINGS CORP、上海温杜颂莱科技有限公司、上海萃达科技有限公司及超百家品牌运营公司共同打造（上述公司简称A星公司），旨在通过选拔并联合各行业优秀生产企业和服务企业，践行合法合规、走正道、讲诚信、积极、正能量、阳光下、轻松开心经营的文化理念，以期达到让业者节省经营成本、提高生产经营效益和消费者买到货真价实质优的商品及服务的目标。</div>
        <div class="detailBtn" @click="gotoPage('about')">
          查看详情
          <img src="../assets/btnIcon.png" alt="">
        </div>
      </div>
      <div class="right">
        <img src="../assets/back2.png" alt="">
      </div>
      </div>
    </div>
    <div class="threeCon">
      <div class="title">A星计划是什么？</div>
      <div class="content">
        选拔并联合各行业优秀生产企业和服务企业，形成一个独特的新经济模式、新经济秩序和新经济生态。
      </div>
      <div class="listCon">
        <div class="list">
          <img src="../assets/list.png" alt="">
          <div class="textCon">
            <div class="firstLine">生产企业</div>
            <div class="secondLine">享受品牌价值，杜绝恶性竞争和内卷</div>
          </div>
        </div>
        <div class="list">
          <img src="../assets/list.png" alt="">
          <div class="textCon">
            <div class="firstLine">店铺</div>
            <div class="secondLine">节省营销成本，提高商品利润</div>
          </div>
        </div>
        <div class="list">
          <img src="../assets/list.png" alt="">
          <div class="textCon">
            <div class="firstLine">消费者</div>
            <div class="secondLine">享受货真价实质优的商品及服务</div>
          </div>
        </div>
        <div class="list">
          <img src="../assets/list.png" alt="">
          <div class="textCon">
            <div class="firstLine">合伙人</div>
            <div class="secondLine">助推A星计划，享受长期收益</div>
          </div>
        </div>
      </div>
      <div class="btn">
        <div class="btnCon" @click="gotoPage('joinUs')">加入我们</div>
      </div>
    </div>
    <div class="fourCon">
      <div class="oneBox">
        <div class="oneBoxLeft">
          <div class="oneBoxList left1">
            <img src="../assets/leftIcon.png" alt="" class="iconImg">
            <div class="title">保护正品，低成本有效打假</div>
            <div class="content">商品仅在指定渠道销售，渠道外商品均视为假货</div>
          </div>
          <div class="oneBoxList left2">
            <img src="../assets/leftIcon.png" alt="" class="iconImg">
            <div class="title">避免恶性竞争和内卷</div>
            <div class="content">“配额制”平衡了企业产能与利润，避免恶性竞争和内卷，实施透明、阳光的运行机制</div>
          </div>
          <div class="oneBoxList left3">
            <img src="../assets/leftIcon.png" alt="" class="iconImg">
            <div class="title">产品质量由消费者监督</div>
            <div class="content">仅设差评功能，促使企业自律，专注生产优质商品</div>
          </div>
        </div>
        <div class="oneBoxCenter">
          <img class="oneBoxCenterImg" src="../assets/back1.png" alt="">
        </div>
        <div class="oneBoxRight">
          <div class="oneBoxList right1">
            <img src="../assets/rightIcon.png" alt="" class="iconImg">
            <div class="title">把品牌还给生产企业</div>
            <div class="content">商品仅由授权企业生产，品牌公司统一推广，节省企业营销成本，并获取品牌溢价利润</div>
          </div>
          <div class="oneBoxList right2">
            <img src="../assets/rightIcon.png" alt="" class="iconImg">
            <div class="title">打造快捷低成本的销售渠道</div>
            <div class="content">平台禁止竞价排名、水军、好评、仅退款、网红带货及收费广告，降低营销成本</div>
          </div>
          <div class="oneBoxList right3">
            <img src="../assets/rightIcon.png" alt="" class="iconImg">
            <div class="title">低成本、可持续、安全和便捷的金融服务</div>
            <div class="content">为金融机构提供真实的生产销售数据，帮助企业享受优质金融服务</div>
          </div>
        </div>
      </div>
      <div class="twoBox">
        <div class="morebtn" @click="gotoPage('about')">
          查看更多
          <img class="addBtn" src="../assets/addBtn.png" alt="">
        </div>
      </div>
    </div>
    <div class="fiveCon">
      <div class="title">合作伙伴</div>
      <partner-list />
    </div>
    <div class="sixCon">
      <div class="widthCon">
        <div class="title"><div class="titleBorder"></div>新闻中心</div>
      <div class="list" v-for="(item,index) in newsList" :key="index" @click="goPage('consult',item.id)">
        <img :src="item.img" alt="" class="list_left">
        <div class="list_right">
          <div class="firstLine">{{ item.title }}</div>
          <div class="secondLine">{{ item.publish_date }}</div>
        </div>
      </div>
      <div class="morebtn" @click="gotoPage('newsCenter')">
        查看更多
        <img class="addBtn" src="../assets/addBtn.png" alt="">
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import partnerList from '@/components/partnerList.vue'
import $ from 'jquery'
export default {
  name: 'HomeView',
  components: {
    partnerList: partnerList
  },
  data() {
    return{
      imgHeight: '0px',
      newsList: [],
    }
  },
  mounted() {
    document.title = "A星计划";
    setTimeout(() => {
      this.imgHeight = document.getElementById('carouselImg').offsetHeight + 'px';
    }, 100);
    this.getNewsList();
  },
  methods: {
    goPage(page, id) {
      this.$router.push({path: '/' + page, query: {id: id}})
    },
    gotoPage(page) {
      this.page = page;
      this.$router.push({ path: '/' + page });
    },
    getNewsList() {
      $.ajax({
        type: "get",
        url: "/officialapi/articles/index",
        async: true,
        data: {
          "page": 1,
          "page_size": 4
        },
        success: (data) => {
          if (data["code"] == 0) {
            this.newsList = data.data.list;
          } else {
            this.$message.error(data.msg);
          }
        }
      })
    },
  }
}
</script>
<style lang="less" scoped>
.oneCon{
  img{
    width: 100%;
  }
}
/deep/.el-carousel .el-carousel__indicators{
  display: none;
}
.twoCon{
  background: #E7F3FC;
  padding: 57px 0px 57px 0px;
  .widthCon{
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .left{
    margin-right: 39px;
    .title{
      font-family: Source Han Sans;
      font-size: 48px;
      font-weight: bold;
      line-height: 48px;
      letter-spacing: 0px;
      font-variation-settings: "opsz" auto;
      color: #222222;
      margin-bottom: 35px;
    }
    .content{
      font-family: Source Han Sans;
      font-size: 20px;
      font-weight: normal;
      line-height: 36px;
      letter-spacing: 0px;
      font-variation-settings: "opsz" auto;
      color: #666666;
      text-indent: 2em;
text-align: justify;
    }
    .detailBtn{
      cursor: pointer;
      border-radius: 6px;
      background: #4A90E2;
      font-family: Source Han Sans;
      font-size: 16px;
      font-weight: 500;
      line-height: 34px;
      letter-spacing: 0.2em;
      font-variation-settings: "opsz" auto;
      color: #FFFFFF;
      width: 173px;
      height: 50px;
      margin-top: 18px;
      display: flex;
      justify-content: center;
      align-items: center;
      img{
        margin-left: 14px;
        width: 18px;
        height: 18px;
      }
    }
  }
  .right{
    img{
      height: 480px;
    }
  }
}
.threeCon{
  .title{
    font-family: Source Han Sans;
    font-size: 30px;
    font-weight: bold;
    line-height: 48px;
    letter-spacing: 0px;
    font-variation-settings: "opsz" auto;
    color: #222222;
    text-align: center;
    margin-top: 77px;
  }
  .content{
    font-family: Source Han Sans;
    font-size: 16px;
    font-weight: normal;
    line-height: 24px;
    text-align: center;
    letter-spacing: 0px;
    font-variation-settings: "opsz" auto;
    color: #666666;
    margin-top: 18px;
  }
  .listCon{
    display: flex;
    justify-content: space-between;
    text-align: center;
    box-sizing: border-box;
    padding: 95px 0px 0 0px;
    width: 1200px;
    margin: 0 auto;
    .list{
      position: relative;
      width: 246px;
      height: 211px;
      background: #F3F8FF;
      padding: 92px 28px 30px 28px;
      box-sizing: border-box;
      border-radius: 10px;
      img{
        width: 132px;
        position: absolute;
        top: -58px;
        left: 50%;
        transform: translatex(-50%);
      }
      .textCon{
        .firstLine{
          font-family: Source Han Sans;
          font-size: 20px;
          font-weight: bold;
          line-height: 22px;
          letter-spacing: 0px;
          font-variation-settings: "opsz" auto;
          color: #222222;
        }
        .secondLine{
          font-family: Source Han Sans;
          font-size: 16px;
          font-weight: 350;
          line-height: 26px;
          text-align: center;
          letter-spacing: 0px;
          font-variation-settings: "opsz" auto;
          color: #666666;
          margin-top: 15px;
        }
      }
    }
  }
  .btn{
    margin-top: 59px;
    margin-bottom: 85px;
    text-align: center;
    .btnCon{
      display: inline-block;
      font-family: Source Han Sans;
      font-size: 16px;
      font-weight: normal;
      line-height: 34px;
      letter-spacing: 0px;
      font-variation-settings: "opsz" auto;
      color: #4A90E2;
      border-radius: 213px;
      opacity: 1;
      box-sizing: border-box;
      border: 1px solid #4A90E2;
      width: 173px;
      height: 40px;
      line-height: 40px;
      cursor: pointer;
    }
  }
}
.fourCon{
  background: #F9FAFB;
  height: 768px;
  .oneBox{
    display: flex;
    padding-top: 86px;
    width: 1200px;
    margin: 0 auto;
    .oneBoxList{
      position: relative;
      padding: 13px 0 0 15px;
      .iconImg{
        width: 47.5px;
        height: 47.5px;
        position: absolute;
        top: 0;
        left: 0;
      }
      .title{
        font-family: Source Han Sans;
        font-size: 20px;
        font-weight: bold;
        line-height: 22px;
        letter-spacing: 0px;
        font-variation-settings: "opsz" auto;
        color: #222222;
        margin-bottom: 15px;
      }
      .content{
        font-family: Source Han Sans;
        font-size: 16px;
        font-weight: normal;
        line-height: 26px;
        letter-spacing: 0px;
        font-variation-settings: "opsz" auto;
        color: #666666;
        width: 350px;
      }
    }
    .oneBoxLeft{
      flex: 1;
      position: relative;
      .left1{
        position: absolute;
        top: 0;
        right: -32px;
      }
      .left2{
        position: absolute;
        top: 164px;
      }
      .left3{
        position: absolute;
        bottom: -70px;
        right: 2px;
        .content{
          width: 308.5px;
        }
      }
    }
    .oneBoxCenter{
      flex: 0 0 260px;
      margin-top: 105px;
      .oneBoxCenterImg{
        width: 260px;
        height: 260px;
      }
    }
    .oneBoxRight{
      flex: 1;
      position: relative;
      .right1{
        position: absolute;
        top: 0;
      }
      .right2{
        position: absolute;
        top: 164px;
        right: 0px;
      }
      .right3{
        position: absolute;
        bottom: -70px;
      }
    }
  }
  .twoBox{
    margin-top: 136px;
    text-align: center;
    .morebtn{
      width: 173px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: Source Han Sans;
      font-size: 16px;
      font-weight: normal;
      line-height: 18px;
      display: flex;
      align-items: center;
      letter-spacing: 0px;
      font-variation-settings: "opsz" auto;
      color: #4A90E2;
      border-radius: 438px;
      box-sizing: border-box;
      border: 1px solid #4A90E2;
      margin: 0 auto;
      cursor: pointer;
      .addBtn{
        width: 18px;
        height: 18px;
        margin-left: 10px;
      }
    }
  }
}
.fiveCon{
  text-align: center;
  padding-bottom: 31.5px;
  .title{
    font-family: Source Han Sans;
    font-size: 30px;
    font-weight: bold;
    line-height: 48px;
    letter-spacing: 0px;
    font-variation-settings: "opsz" auto;
    color: #222222;
    margin-top: 78px;
    margin-bottom: 35px;
  }
}
.sixCon{
  background: #F9FAFB;
  padding: 28px 0px 39px 0px;
  .widthCon{
    width: 1200px;
    margin: 0 auto;
  }
  .title{
    display: flex;
    align-items: center;
    .titleBorder{
      display: inline-block;
      width: 6px;
      height: 20px;
      border-radius: 1px;
      background: #4A90E2;
      margin-right: 10px;
    }
    margin-bottom: 3px;
    font-family: Source Han Sans;
    font-size: 20px;
    font-weight: bold;
    line-height: 22px;
    letter-spacing: normal;
    color: #222222;
  }
  .list{
    padding: 22px 0 24px 0;
    border-bottom: 0.5px solid #D8D8D8;
    display: flex;
    align-items: center;
    cursor: pointer;
    .list_left{
      width: 200px;
      height: 100px;
      border-radius: 10px;
      margin-right: 23px;
    }
    .list_right{
      .firstLine{
        font-family: Source Han Sans;
        font-size: 20px;
        font-weight: bold;
        line-height: 22px;
        letter-spacing: normal;
        color: #222222;
        margin-bottom: 35px;
      }
      .secondLine{
        font-family: Source Han Sans;
        font-size: 14px;
        font-weight: normal;
        line-height: 22px;
        letter-spacing: normal;
        color: #666666;
      }
    }
  }
  .morebtn{
    width: 173px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: Source Han Sans;
    font-size: 16px;
    font-weight: normal;
    line-height: 18px;
    display: flex;
    align-items: center;
    letter-spacing: 0px;
    font-variation-settings: "opsz" auto;
    color: #4A90E2;
    border-radius: 438px;
    box-sizing: border-box;
    border: 1px solid #4A90E2;
    margin: 0 auto;
    cursor: pointer;
    margin-top: 32px;
    .addBtn{
      width: 18px;
      height: 18px;
      margin-left: 10px;
    }
  }
}
</style>
